module.exports = __webpack_public_path__ + "img/subheader_mobile_psoriasis.svg";